export enum AuthMethodEnum {
  Internal = 0,
  Facebook = 1,
  Apple = 2,
}
